<template>
  <div class="my-6 has-text-centered">
    <img :src="$root.isEnneagram ? '/img/enneagram/spinner.svg' : '/img/spinner.svg'" class="is-inline-block mb-5" width="80" height="80"/>
    <p class="text">{{ text || $t('common.loading') }}...</p>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    text: { type: String }
  },
}
</script>

<style lang="scss" scoped>
.text {
  color: #9fc6e6;
}

.enneagram {
  .text {
    color: #4a4a4a;
  }
}
</style>